import { ParamConfig } from '@smartproxy/sp-utils';

import { UseFormReturn } from '@/hooks/useForm';

import Badge from '@/components/atoms/badge';
import { Input } from '@/components/atoms/input';
import { InputDropdown } from '@/components/atoms/inputDropdown';

import IconLink from '~/svg/IconLink.svg';
import IconTarget from '~/svg/IconTarget.svg';

interface FormFieldProps {
  param: ParamConfig;
  form: UseFormReturn<Record<string, string>>;
}

export const FormField = ({ param, form }: FormFieldProps) => {
  const field = form.getFieldProps(param.key);

  if (param.type === 'text') {
    return (
      <Input
        {...field}
        autoComplete='off'
        label={param.header}
        leftIcon={
          param.key === 'query' ? (
            <IconTarget />
          ) : param.key === 'url' ? (
            <IconLink />
          ) : null
        }
        placeholder=''
      />
    );
  }

  if (param.type === 'select') {
    const options =
      param.options?.map((option) => {
        if (typeof option === 'string') {
          return {
            label: option,
            value: option.toString(),
          };
        }
        return {
          label: option.label,
          value: option.value.toString(),
        };
      }) ?? [];

    return (
      <InputDropdown
        {...field}
        label={
          <Badge size='s' colors='neutral-N99'>
            {param.header}
          </Badge>
        }
        placeholder='No selection'
        options={options}
        onOptionChange={(value) => form.setFieldValue(field.name, value)}
        classNames={{
          root: 'w-full text-left',
          inputField: 'w-full',
        }}
        hasSearch
      />
    );
  }

  return null;
};
